import React from 'react';
import {WordPressPost} from "./interfaces";
import Sidebar from "./Sidebar";
import defaultTitleBackgroundImage from '../../assets/img/press-releases.jpg';
import '../../styles/pressReleases.css';

interface NewsPostProps {
    post: WordPressPost
}

const NewsPost = (props: NewsPostProps) => {
    const { post } = props;
    const backgroundImage = post.featured_media ? post.featured_media : defaultTitleBackgroundImage;

    const postContentSection1 = {
        backgroundImage: `url(${backgroundImage})`
    }

    const convertFontSizeClassesToInlineStyles = (postContent: string) => {
        // Create a map of WordPress font size classes to their respective font sizes
        const fontSizeClassMap = {
            'has-small-font-size': '14px',
            'has-medium-font-size': '17px',
            'has-large-font-size': '22px',
            'has-extra-large-font-size': '26px',
        };

        for (const [className, fontSize] of Object.entries(fontSizeClassMap)) {
            const regex = new RegExp(`class="([^"]*\\s)?${className}(\\s[^"]*)?"`, 'g');
            postContent = postContent.replace(regex, (match) => {
                return match.replace(`class="${className}"`, `style="font-size: ${fontSize};"`);
            });
        }

        return postContent;
    }
    const convertWpToHtml = (wpString: string) => {
        // Remove WordPress block comments and retain only HTML tags
        return wpString
            .replace(/<!-- wp:.*?-->/g, '')     // Remove opening comments like <!-- wp:paragraph -->
            .replace(/<!-- \/wp:.*?-->/g, '');  // Remove closing comments like <!-- /wp:paragraph -->
    };

    const convertedContent = convertWpToHtml(post.content);
    const htmlOutput = convertFontSizeClassesToInlineStyles(convertedContent);

    const defaultContentFooter = (
        <div className='post-content-inner-text'>
            <p style={{fontWeight: '600', margin: '27px 0 27px 0'}}>###</p>
            <p>
                <span style={{textDecoration: "underline", fontWeight: "600"}}>
                    About LinkNYC<br/>
                </span>
                LinkNYC is the world's largest and fastest free public Wi-Fi network. Each Link kiosk provides
                free superfast Wi-Fi, phone calls, device charging, access to social services,
                and displays content such as real-time weather, transit info, public art, and local information.
                The city-wide network has more than 13 million Wi-Fi users and has connected more than 25 million free phone calls.
                All of LinkNYC's services are completely free to users and taxpayers, provided by CityBridge,
                a partnership led by Intersection and ZenFi Networks.
                The second generation offering will deploy thousands of new kiosks, called Link5G,
                enabled with 5G wireless technology across the city.
                For more information about LinkNYC or to find a Link near you, visit&nbsp;
                <a style={{textDecoration: 'none'}} href="http://www.link.nyc">
                    www.link.nyc
                </a>.
            </p>
            <p>
                <span style={{textDecoration: "underline", fontWeight: "600"}}>
                    About Intersection<br/>
                </span>
                Intersection is a member of the consortium behind LinkNYC.
                Intersection is an experience-driven Out of Home media and technology company that delivers programming,
                consumer amenities, and advertising to cities. From free internet access to wayfinding to real-time information,
                our products make city life easier and more sustainable. We further enrich cities with experiential
                programming that inspires and engages people throughout their day. With valuable, diverse audiences
                in America's top cities, we provide innovative, data-driven solutions for brands to reach urbanites at scale.
                For more information, visit&nbsp;
                <a style={{textDecoration: 'none'}} href="http://www.intersection.com">
                    www.intersection.com
                </a>.
                </p><br/>
        </div>
    );

    const postContent = (
        <div className='post-content'>
            <h3>
                <div></div>
            </h3>
            <div className='post-content-date'>{post.post_date}</div>
            <div className='post-content-inner-text' dangerouslySetInnerHTML={{ __html: htmlOutput }} ></div>
            {defaultContentFooter}
        </div>
    );

    return (
        <div className='top-div'>
            <section className='post-content-section-1' style={postContentSection1}>
                <div className='post-content-section-1-div'>
                    <h2>
                        <div></div>
                        {post.title}
                    </h2>
                </div>
            </section>
            <section className='post-content-section-2'>
                <Sidebar />
                {postContent}
            </section>
        </div>
    );
}

export default NewsPost;
